angular.module('impactx.rfq').controller('DecideRFQCtrl', DecideRFQCtrl);

DecideRFQCtrl.$inject = ['$scope', 'dataGen', '$context', '$redirect', 'themeFactory', 'TranslationService', '$mdDialog', 'proId', 'amount'];

function DecideRFQCtrl($scope, dataGen, $context, $redirect, themeFactory, TranslationService, $mdDialog, proId, amount) {
    $scope.abortLabel = TranslationService.get("abort");
    $scope.requiredLabel = TranslationService.get("required");
    $scope.noSelectedItemMessageLabel = TranslationService.get("noSelectedItemMessage");
    $scope.theme = themeFactory.getTheme();

    dataGen.getData($scope, {proId: proId, amount: amount}, "/rfq/decide/view");

    this.decideRFQProcess = function () {
        var dataObj = {proId: proId, amount: amount};
        var tempScope = {};
        dataGen.postAsForm(tempScope, dataObj, '/rfq/decide/rfqprocess').then(function () {
            $context.refreshBasket($scope, dataGen, $context);
            $mdDialog.hide(tempScope.trns.success);
        })
    };

    this.decideCatProcess = function () {
        var dataObj;
        if ($scope.data.hasSBTA || !$scope.data.hasLicence) {
            dataObj = {
                proId: proId,
                amount: amount,
                price2: $scope.data.singlePrice2.value,
                currency2: $scope.data.currency2.selected.id,
                tax2: $scope.data.taxRate2.selected.id
            };
        }
        else {
            dataObj = {
                proId: proId,
                amount: amount,
                price2: 0,
                currency2: "",
                tax2: 0
            };
        }
        var tempScope = {};
        dataGen.postAsForm(tempScope, dataObj, '/rfq/decide/catprocess').then(function () {
            $context.refreshBasket($scope, dataGen, $context);
            $mdDialog.hide(tempScope.trns.success);
        })
    };

    this.cancel = function () {
        $mdDialog.cancel();
    };
}